module.exports = __webpack_public_path__ + "static/media/YS_upto25valueboost_Trans_EN.ca661dfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YS_upto25valueboost_Trans_EN.png
// module id = 419
// module chunks = 0